import PropTypes from 'prop-types';
import template from './itemRowBase.jsx';
import displayNames from '../displayNames';
import compose from '../../hoc/compose';
var ItemRowBase = template;
ItemRowBase.displayName = displayNames.SORT_BY_DRAG_LIST_ITEM_ROW_BASE;
ItemRowBase.propTypes = {
  dragHandle: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dragHandleEnabled: PropTypes.bool,
  dragHandleTooltipContent: PropTypes.string,
  isDragging: PropTypes.bool,
  skin: PropTypes.oneOf(['standard', 'general'])
};
ItemRowBase.defaultProps = {
  dragHandle: true,
  dragHandleEnabled: true
};
export default compose(ItemRowBase);